// import { useEffect, useRef, useState } from "react";
// import { FiMoreHorizontal, FiEye, FiEdit, FiTrash2 } from "react-icons/fi";
// import { IoMdStar } from "react-icons/io";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";

// const TestimonialList = () => {
//   const navigate = useNavigate();
//   const [testimonials, setTestimonials] = useState([]);
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
//   const [deleteId, setDeleteId] = useState(null);

//   const btnRefs = useRef({});
//   const menuRef = useRef(null);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
// const itemsPerPage = 10; // now 10 per page

//   useEffect(() => {
//     fetchTestimonials();
//   }, []);

//   const fetchTestimonials = async () => {
//     try {
//       const res = await api({
//         url: SummaryApi.getAllTestimonials.url,
//         method: SummaryApi.getAllTestimonials.method,
//       });
//       const data = res?.data?.data || [];
//       setTestimonials(data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleToggle = (id) => {
//     const btn = btnRefs.current[id];
//     if (btn) {
//       const rect = btn.getBoundingClientRect();
//       setMenuPosition({ top: rect.bottom + 8, left: rect.left });
//     }
//     setOpenMenuId(openMenuId === id ? null : id);
//   };

//   const confirmDelete = async () => {
//     try {
//       await api({
//         url: SummaryApi.deleteOneTestimonial.url(deleteId),
//         method: SummaryApi.deleteOneTestimonial.method,
//       });
//       toast.success("Deleted successfully ✅");
//       fetchTestimonials(); // refresh list
//       setDeleteId(null);
//     } catch (error) {
//       toast.error("Delete failed");
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         menuRef.current &&
//         !menuRef.current.contains(event.target) &&
//         !Object.values(btnRefs.current).some((btn) =>
//           btn?.contains(event.target)
//         )
//       ) {
//         setOpenMenuId(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () =>
//       document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Pagination logic
//   const totalPages = Math.ceil(testimonials.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentTestimonials = testimonials.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="p-2">
//       {/* Header */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-6">
//       <h1 className="text-2xl md:text-3xl font-serif text-gray-800">
//           Testimonial List
//         </h1>
//         <button
//           onClick={() =>
//             navigate("/admin-panel/testimonial-list/testimonial-form")
//           }
//           className="bg-[#45A301] text-white px-4 py-2 rounded-md text-sm"
//         >
//           Add Testimonial
//         </button>
//       </div>

//       {/* TABLE */}
//       <div className="border rounded-lg overflow-hidden">
//         <div className="overflow-x-auto no-scrollbar">
//           <div className="min-w-[600px] grid grid-cols-[2fr_1fr_1fr_80px] bg-gray-50 px-6 py-3 text-sm font-medium text-gray-600">
//             <div>Client & Location</div>
//             <div className="text-center">Rating</div>
//             <div className="text-center">Status</div>
//             <div className="text-center">Actions</div>
//           </div>

//           {currentTestimonials.length === 0 ? (
//             <div className="px-6 py-10 text-center text-gray-500">
//               No testimonials found
//             </div>
//           ) : (
//             currentTestimonials.map((item) => (
//               <div
//                 key={item._id}
//                 className="min-w-[600px] grid grid-cols-[2fr_1fr_1fr_80px] items-center px-6 py-4 text-sm border-t hover:bg-[#F7F9F4]"
//               >
//                 <div className="font-medium truncate">
//                   {item.name}, {item.location}
//                 </div>

//                 <div className="flex justify-center gap-1">
//                   {[1, 2, 3, 4, 5].map((i) => (
//                     <IoMdStar
//                       key={i}
//                       className={`w-4 h-4 ${
//                         i <= item.rating
//                           ? "fill-[#45A301] text-[#6f8f2f]"
//                           : "text-gray-300"
//                       }`}
//                     />
//                   ))}
//                 </div>

//                 <div className="flex justify-center">
//                   <span
//                     className={`px-3 py-1 rounded-md text-xs font-medium ${
//                       item.status === "Publish"
//                         ? "bg-green-100 text-green-700"
//                         : "bg-red-100 text-red-600"
//                     }`}
//                   >
//                     {item.status}
//                   </span>
//                 </div>

//                 <div className="flex justify-center relative">
//                   <button
//                     ref={(el) => (btnRefs.current[item._id] = el)}
//                     onClick={() => handleToggle(item._id)}
//                     className="p-2 rounded hover:bg-gray-200"
//                   >
//                     <FiMoreHorizontal size={18} />
//                   </button>

//                   {openMenuId === item._id && (
//                     <div
//                       ref={menuRef}
//                       className="fixed w-36 bg-white border rounded-lg shadow-lg text-sm z-[9999]"
//                       style={{
//                         top: menuPosition.top,
//                         left: menuPosition.left,
//                       }}
//                     >
//                       <button
//                         onClick={() =>
//                           navigate(
//                             `/admin-panel/testimonial-list/testimonial-form?mode=view&id=${item._id}`
//                           )
//                         }
//                         className="flex items-center gap-2 w-full px-4 py-2 hover:bg-gray-100"
//                       >
//                         <FiEye /> View
//                       </button>

//                       <button
//                         onClick={() =>
//                           navigate(
//                             `/admin-panel/testimonial-list/testimonial-form?mode=edit&id=${item._id}`
//                           )
//                         }
//                         className="flex items-center gap-2 w-full px-4 py-2 hover:bg-gray-100"
//                       >
//                         <FiEdit /> Edit
//                       </button>

//                       <button
//                         onClick={() => {
//                           setOpenMenuId(null);
//                           setDeleteId(item._id);
//                         }}
//                         className="flex items-center gap-2 w-full px-4 py-2 text-red-600 hover:bg-gray-100"
//                       >
//                         <FiTrash2 /> Delete
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))
//           )}
//         </div>

//         {/* Pagination controls */}
//         {totalPages >= 1 && (
//   <div className="flex items-center justify-between bg-gray-100 px-4 py-3 border-t">
//     <div className="text-sm text-gray-600">
//       Page {currentPage} of {totalPages}
//     </div>

//     <div className="flex gap-2">
//       <button
//         onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
//         disabled={currentPage === 1}
//         className="px-3 py-1 border rounded bg-white disabled:opacity-50"
//       >
//         Previous
//       </button>

//       <button
//         onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
//         disabled={currentPage === totalPages}
//         className="px-3 py-1 border rounded bg-[#45A301] text-white disabled:opacity-50"
//       >
//         Next
//       </button>
//     </div>
//   </div>
// )}
//       </div>

//       {/* DELETE CONFIRM MODAL */}
//       {deleteId && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg">
//             <h2 className="text-lg font-semibold mb-2">Confirm Delete</h2>
//             <p className="text-sm text-gray-500 mb-6">
//               Are you sure you want to delete this testimonial?
//             </p>

//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setDeleteId(null)}
//                 className="px-4 py-2 border rounded-md text-sm"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmDelete}
//                 className="px-4 py-2 bg-red-500 text-white rounded-md text-sm"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TestimonialList;

import { useState, useRef, useEffect, useMemo } from "react";
import { FiMoreHorizontal, FiEye, FiEdit, FiTrash2, FiDownload, FiX, FiPlus } from "react-icons/fi";
import { IoMdStar } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";
import * as XLSX from "xlsx";
import PageLoader from "../helpers/PageLoader";

const TestimonialList = () => {
  const [loading, setLoading] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All Status");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [deleteId, setDeleteId] = useState(null);

  const btnRefs = useRef({});
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Fetch testimonials
  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const res = await api({
        url: SummaryApi.getAllTestimonials.url,
        method: SummaryApi.getAllTestimonials.method,
      });
      const data = res?.data?.data || [];
      setTestimonials(data);
    } catch (error) {
      console.error("Fetch testimonials error:", error);
      toast.error("Failed to load testimonials");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  // Filtering Logic
  const filteredData = useMemo(() => {
    let data = testimonials;
    if (filter !== "All Status") {
      data = data.filter((item) => item.status === filter);
    }
    if (search) {
      const term = search.toLowerCase();
      data = data.filter(
        (item) =>
          item.name?.toLowerCase().includes(term) ||
          item.location?.toLowerCase().includes(term) ||
          item.review?.toLowerCase().includes(term)
      );
    }
    return data;
  }, [testimonials, search, filter]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  
  const currentData = useMemo(() => {
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredData, startIndex]);

  // EXPORT TO EXCEL
  const exportToExcel = () => {
    const excelData = filteredData.map((item) => ({
      "Client Name": `${item.name || ""}`,
      "Location": `${item.location || ""}`,
      "Rating": `${item.rating || 0} Stars`,
      "Status": `${item.status || ""}`,
      "Review": `${item.review || ""}`,
      "Created Date": `${new Date(item.createdAt).toLocaleDateString()}`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const colWidths = Object.keys(excelData[0] || {}).map((key) => {
      const headerLen = key.length;
      const maxCellLen = excelData.reduce((max, row) => {
        const cellLen = row[key] ? row[key].toString().length : 0;
        return Math.max(max, cellLen);
      }, headerLen);
      return { wch: Math.max(headerLen, Math.min(maxCellLen, 50)) + 2 };
    });

    worksheet["!cols"] = colWidths;
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Testimonials");
    XLSX.writeFile(workbook, "Testimonial_List.xlsx");
  };

  // Boundary Aware Toggle
  const handleToggle = (id) => {
    if (openMenuId === id) {
      setOpenMenuId(null);
      return;
    }
    const button = btnRefs.current[id];
    if (!button) return;

    const rect = button.getBoundingClientRect();
    const dropdownHeight = 120; 
    const dropdownWidth = 140;
    
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let topPosition;
    if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
      topPosition = rect.top - dropdownHeight;
    } else {
      topPosition = rect.bottom + 5;
    }

    setMenuPosition({ 
      top: topPosition, 
      left: rect.left - dropdownWidth + rect.width 
    });
    setOpenMenuId(id);
  };

  // Delete Functionality
  const confirmDelete = async () => {
    try {
      await api({
        url: SummaryApi.deleteOneTestimonial.url(deleteId),
        method: SummaryApi.deleteOneTestimonial.method,
      });
      toast.success("Deleted successfully ✅");
      setTestimonials(prev => prev.filter(t => t._id !== deleteId));
      setDeleteId(null);
    } catch (error) {
      toast.error("Delete failed");
      console.error(error);
    }
  };

  useEffect(() => {
    const handleEvents = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) &&
          !Object.values(btnRefs.current).some((btn) => btn?.contains(event.target))) {
        setOpenMenuId(null);
      }
    };
    const handleScrollResize = () => setOpenMenuId(null);

    document.addEventListener("mousedown", handleEvents);
    window.addEventListener("scroll", handleScrollResize, true);
    window.addEventListener("resize", handleScrollResize);
    return () => {
      document.removeEventListener("mousedown", handleEvents);
      window.removeEventListener("scroll", handleScrollResize, true);
      window.removeEventListener("resize", handleScrollResize);
    };
  }, []);

  if (loading) return <PageLoader />;

  return (
    <div>
      {/* Header Section */}
      <div className="flex justify-between items-center mb-2">
        <h1 className="text-2xl pb-4 md:text-3xl font-serif text-gray-800">
          Testimonial List
        </h1>
        <div className="flex gap-2 mb-4">
            <button
            onClick={() => navigate("/admin-panel/testimonial-list/testimonial-form")}
            className="flex items-center gap-2 bg-[#45A301] text-white px-4 py-2 rounded-md text-sm hover:bg-[#3a8a01] transition-all"
            >
            <FiPlus size={16} />
            <span>Add Testimonial</span>
            </button>
            <button
            onClick={exportToExcel}
            className="flex items-center gap-2 bg-white border px-4 py-2 rounded-md text-sm hover:bg-gray-50 transition-all"
            >
            <FiDownload size={16} />
            <span>Export</span>
            </button>
        </div>
      </div>

      {/* Controls Section */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <input
          type="text"
          placeholder="Search by client name or location..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="border rounded-md px-4 py-2 text-sm w-full lg:w-80 outline-none focus:ring-2 ring-gray-200"
        />

        <div className="flex flex-wrap items-center gap-3">
          <select
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
              setCurrentPage(1);
            }}
            className="border rounded-md px-4 py-2 text-sm outline-none"
          >
            <option>All Status</option>
            <option value="Publish">Publish</option>
            <option value="Draft">Draft</option>
          </select>

          <div className="text-sm text-gray-500">
            Showing {filteredData.length} entries
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto scrollbar-hide border rounded-lg bg-white">
        <div className="min-w-[700px]">
          <div className="grid grid-cols-[2fr_1fr_1fr_80px] bg-gray-100 px-6 py-4 text-sm font-semibold text-gray-700">
            <div>Client & Location</div>
            <div className="text-center">Rating</div>
            <div className="text-center">Status</div>
            <div className="text-center">Actions</div>
          </div>

          {currentData.length === 0 ? (
            <div className="px-6 py-10 text-center text-gray-500">
              No testimonials found
            </div>
          ) : (
            currentData.map((item) => (
              <div
                key={item._id}
                className="grid grid-cols-[2fr_1fr_1fr_80px] items-center px-6 py-4 text-sm border-t hover:bg-[#F7F9F4] transition-colors"
              >
                <div className="font-medium text-gray-800 line-clamp-1">
                    {item.name}, <span className="text-gray-500 font-normal">{item.location}</span>
                </div>
                
                <div className="flex justify-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <IoMdStar
                      key={star}
                      className={`w-4 h-4 ${
                        star <= item.rating ? "text-[#45A301]" : "text-gray-300"
                      }`}
                    />
                  ))}
                </div>

                <div className="flex justify-center">
                  <span className={`px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider ${
                    item.status === "Publish" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
                  }`}>
                    {item.status || "Draft"}
                  </span>
                </div>

                <div className="flex justify-center">
                  <button
                    ref={(el) => (btnRefs.current[item._id] = el)}
                    onClick={() => handleToggle(item._id)}
                    className="p-2 hover:bg-gray-200 rounded-full transition-colors"
                  >
                    <FiMoreHorizontal size={18} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Action Dropdown */}
        {openMenuId && (
          <div
            ref={menuRef}
            className="fixed w-36 bg-white border rounded-lg shadow-xl text-sm z-[9999] overflow-hidden"
            style={{ top: menuPosition.top, left: menuPosition.left }}
          >
            <button
              onClick={() => navigate(`/admin-panel/testimonial-list/testimonial-form?mode=view&id=${openMenuId}`)}
              className="flex items-center gap-2 w-full px-4 py-3 hover:bg-gray-100 text-gray-700"
            >
              <FiEye className="text-blue-500" /> View
            </button>
            <button
              onClick={() => navigate(`/admin-panel/testimonial-list/testimonial-form?mode=edit&id=${openMenuId}`)}
              className="flex items-center gap-2 w-full px-4 py-3 hover:bg-gray-100 text-gray-700 border-t"
            >
              <FiEdit className="text-orange-500" /> Edit
            </button>
            <button
              onClick={() => { setDeleteId(openMenuId); setOpenMenuId(null); }}
              className="flex items-center gap-2 w-full px-4 py-3 hover:bg-red-50 text-red-600 border-t"
            >
              <FiTrash2 /> Delete
            </button>
          </div>
        )}

        {/* Pagination Footer */}
        {filteredData.length > 0 && (
          <div className="flex items-center justify-between bg-gray-50 px-6 py-4 border-t">
            <div className="text-sm text-gray-600 font-medium">
              Page {currentPage} of {totalPages}
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                className="px-4 py-1.5 border rounded-md bg-white text-sm font-medium disabled:opacity-40 hover:bg-gray-50"
              >
                Previous
              </button>
              <button
                onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-4 py-1.5 border rounded-md bg-[#45A301] text-white text-sm font-medium disabled:opacity-50 hover:bg-[#3a8a01] transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteId && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[10000] p-4">
          <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl overflow-hidden">
            <div className="flex justify-between items-center border-b px-6 py-4 bg-gray-50">
              <h3 className="font-bold text-gray-800">Delete Testimonial</h3>
              <button onClick={() => setDeleteId(null)} className="p-1 hover:bg-gray-200 rounded-full">
                <FiX size={20} />
              </button>
            </div>
            <div className="px-6 py-6 text-sm text-gray-600">
              Are you sure you want to delete this testimonial? This action cannot be undone.
            </div>
            <div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
              <button 
                onClick={() => setDeleteId(null)}
                className="px-4 py-2 border rounded-md text-sm font-medium hover:bg-white"
              >
                Cancel
              </button>
              <button 
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700"
              >
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestimonialList;